import { DELETE_DMX_UNIVERSE, DELETE_DMX_UNIVERSE_SUCCESSFUL, DELETE_DMX_UNIVERSE_FAILED } from './actionTypes';

export const deleteDmxUniverse = (universe) => {
  return {
    type: DELETE_DMX_UNIVERSE,
    payload: { universe },
  };
};

export const deleteDmxUniverseSuccessful = (message) => {
  return {
    type: DELETE_DMX_UNIVERSE_SUCCESSFUL,
    payload: message,
  };
};

export const deleteDmxUniverseFailed = (message) => {
  return {
    type: DELETE_DMX_UNIVERSE_FAILED,
    payload: message,
  };
};
